import { ShieldCheck } from "lucide-react";
import { GUARANTEE } from "../data/mock";

export const GuaranteeSection = () => {
  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-3xl overflow-hidden" style={{ background: 'linear-gradient(135deg, #edf1f9 0%, #f8fafc 50%, #edf1f9 100%)' }}>
          {/* Inner border glow */}
          <div className="absolute inset-[1px] rounded-3xl border border-navy-200/30" />
          
          {/* Corner decorations */}
          <div className="absolute top-0 left-0 w-24 h-24">
            <div className="absolute top-4 left-4 w-12 h-12 border-t-2 border-l-2 border-hevi-blue/30 rounded-tl-2xl" />
          </div>
          <div className="absolute bottom-0 right-0 w-24 h-24">
            <div className="absolute bottom-4 right-4 w-12 h-12 border-b-2 border-r-2 border-hevi-blue/30 rounded-br-2xl" />
          </div>

          <div className="relative z-10 text-center p-10 sm:p-14 lg:p-16">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-navy-100/60 mb-7">
              <ShieldCheck size={30} className="text-hevi-blue" />
            </div>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-navy-900 mb-6">
              OUR <span className="text-hevi-red">"ZERO-HEADACHE"</span> GUARANTEE
            </h2>
            <p className="text-slate-500 text-[16px] leading-relaxed max-w-2xl mx-auto">
              {GUARANTEE.description}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
